<template>
  <div class="purchaseOrder">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="送货单详情"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="model"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <table class="gridtable" style="width: 100%;" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">供应商编码:</td>
            <td style="width: 23%">{{model.supplierNo}}</td>
            <td class="tableLabel">供应商名称:</td>
            <td style="width: 23%">{{model.supplierName}}</td>
            <td class="tableLabel">送货人:</td>
            <td>{{model.shipper}}</td>
          </tr>
          <tr>
            <td class="tableLabel">联系方式:</td>
            <td>{{model.shipperPhone}}</td>
            <td class="tableLabel">送货方式:</td>
            <td>{{model.deliveryMethod}}</td>
            <td class="tableLabel">预计发货日期:</td>
            <td>{{model.plannedArrivalTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">预计到货日期:</td>
            <td>{{model.deliveryDate}}</td>
            <td class="tableLabel">备注:</td>
            <td>{{model.note}}</td>
            <td class="tableLabel">过账日期:</td>
            <td>
              <el-date-picker
                  v-model="model.postTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="选择日期"/>
            </td>
          </tr>
        </table>
        <el-table
            :data="model.inspectionReportVOS"
            border
            style="width: 100%">
          <el-table-column
              prop="purchaseOrderNo"
              align="center"
              label="采购订单号"
              show-overflow-tooltip
              width="100"/>
          <el-table-column prop="purchaseOrderRowNo" align="center" label="行号" width="80"/>
          <el-table-column
              prop="materialNo"
              align="center"
              label="物料编号"
              show-overflow-tooltip
              width="120"/>
          <el-table-column
              prop="mappingMaterialNo"
              align="center"
              label="旧物料号"
              show-overflow-tooltip
              width="120"/>
          <el-table-column
              prop="materialName"
              align="left"
              label="物料描述"
              min-width="120"
              show-overflow-tooltip/>
          <el-table-column prop="requireDeliveryDate" align="center" label="交货期" width="100">
            <template slot-scope="scope">
              <span>{{scope.row.requireDeliveryDate ? scope.row.requireDeliveryDate.substring(0, 10) : ""}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="submissionNum" align="center" label="需求数" width="70"/>
          <el-table-column prop="qualifiedNum" align="center" label="合格数量" width="70"/>
          <el-table-column prop="finalStorageQuantity" align="center" label="本次入库数量" width="100">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.finalStorageQuantity" placeholder="请输入" @input="checkQuantity(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="location" align="center" label="库位" width="120">
            <template slot-scope="scope">
              <el-select v-model="scope.row.location" placeholder="请选择">
                <el-option
                    v-for="item in constants.locationNo.$options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="locationNo" align="center" label="库存仓位" width="150"/>
          <el-table-column prop="note" align="center" label="备注" width="150">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.note" placeholder="请输入"/>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button
            v-if="model.inspectionReportVOS.length>0"
            type="primary"
            style="margin: 10px 0 10px 0"
            :loading="submitLoading"
            @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";

  export default {
    name:"DeliveryInStockDetail",
    components: {},
    data() {
      return {
        constant,
        constants,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        no: "",
        model: {
          pkid:"",
          supplierNo: "", // 供应商编码
          supplierName: "", // 供应商名称
          inspectionReportVOS: [], // 送货单明细
          postTime:"",
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(no) {
        // console.log(no);
        this.no = no;
        this.getData();
      },
      checkQuantity(row) {
        console.log(row);
        if (row.finalStorageQuantity>row.submissionNum) {
          this.$message.error("入库数量已超出");
        }
        if (row.finalStorageQuantity== null || row.finalStorageQuantity==="") {
          this.$message.error("入库数量不能为空");
        }
        if (row.finalStorageQuantity > row.qualifiedNum) {
          this.$message.error("入库数量不可大于合格数量");
        }
      },
      getData() {
        this.$http.get("basic", "incomings/qCByPurchaseReceiveNo/" + this.no)
          .then((resp) => {
            console.log(resp.data);
            this.model = resp.data;
            this.model.postTime = this.getFormatDate(new Date());
            console.log(resp);
            if (this.model.inspectionReportVOS.length===0) {
              this.$message.error("该送货单质检不通过或者未质检！");
            } else {
              this.dialogVisible = true;
            }
            this.model.inspectionReportVOS.forEach(item=>{
              if (item.finalStorageQuantity === null || item.finalStorageQuantity === "") {
                item.finalStorageQuantity = item.qualifiedNum;
              }
            });
          });
      },
      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate + " 00:00:00";
      },
      submit() {
        for (let item of this.model.inspectionReportVOS) {
          if (item.finalStorageQuantity>item.submissionNum) {
            this.$message.error("入库数量已超出");
          }
          if (item.finalStorageQuantity==null || item.finalStorageQuantity=="") {
            this.$message.error("入库数量不能为空");
          }
          if (item.finalStorageQuantity > item.qualifiedNum) {
            this.$message.error("入库数量不能大于合格数量");
          }
        }
        this.submitLoading = true;
        this.$http
          .put("basic", "incomings/inStock", this.model)
          .then((res) => {
            if (res.success) {
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$message.success("修改成功");
            }
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .purchaseOrder{
    .el-form-item__content{
      margin-left: 2%!important;
    }
    table.gridtable {
      font-family: verdana,arial,sans-serif;
      font-size:11px;
      color:#333333;
      border: 1px solid #EBEEF5;
      border-bottom: none;
      border-left: none;
      margin-bottom: 15px;
    }
    table.gridtable tr td {
      padding: 8px;
      border-left: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
    }
    .tableLabel {
      width: 10%;
      text-align: right;
      background-color: #D1E6F5;
      border-left: 1px solid #EBEEF5;
    }
  }

</style>
